import { Directive, Input, OnDestroy } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { NavService } from '../../core/nav.service';
import { User } from "../shared/user";
import { NavItem } from "../../core/navbar/nav-item";
import { ObjectObservable } from "../../shared/base/object-observable";

@Directive({
  selector: 'app-user-detail-nav'
})
export class UserDetailNavDirective implements OnDestroy {

  private navList: NavItem[];

  constructor(private route: ActivatedRoute, private nav: NavService) { }

  ngOnDestroy() {
    this.nav.navList = null;
    this.nav.subList = null;
  }

  @Input() set userObservable(user: ObjectObservable<User>) {

    if(user) {
      this.navList = [
        {
          text: "Overview",
          commands: ["./users", user.$ref.key]
        }
        // {
        //   text: "Profile",
        //   commands: ["profile"],
        //   route: this.route.firstChild
        // }
      ]

      this.nav.subList = {
        title: 'subList',
        items: this.navList
      };

      this.nav.navList = {
        title: 'My Page Navigation',
        items: this.navList
      };
    }
  }
}



// WEBPACK FOOTER //
// /Users/JunnieJobs/git/nextstep-fe2/src/app/users/user-detail/user-detail-nav.directive.ts